<template>
  <div :class="['vitem','flex-between', { disable }]">
    <div class="vitem-left">
      <div class="vitem-left-title one-ellipsis" v-html="title" />
      <div class="vitem-left-minimum" @click.stop="onShowDetail">
        {{ $t('checkout.minTransaction') }}
        {{ $n(info.minimumTransaction || 0, 'currency', 'id-ID') }}
        <q-icon name="svg:toright" style="fill: none; stroke: #9ca3af" />
      </div>
    </div>
    <div class="vitem-right">
<!--      <q-btn-->
<!--        v-if="info.needClaim"-->
<!--        no-caps-->
<!--        unelevated-->
<!--        color="primary"-->
<!--        class="claim-btn border-radius-8 text-weight-bolder font-size-16"-->
<!--        @click="onClickClaimBtn"-->
<!--      >-->
<!--        {{ $t('order.checkout.claim') }}-->
<!--      </q-btn>-->
      <i
        class="vitem-right-check iconfont mr-1"
        :class="[
          `dm-Checkbox-${isChoose ? 'selected' : 'unselected'}`,
          { nocheck: !isChoose },
        ]"
        @click="onChoose"
      />
    </div>
  </div>
</template>

<script>
const PROMO_CONDITION = {
  app: 1,
};
export default {
  // eslint-disable-next-line vue/require-prop-types
  props: ['info', 'curs', 'keyword'],
  computed: {
    title() {
      const { info, keyword } = this;
      let value = `${info.name} (${info.promoCode})`;
      if (keyword.trim() === '') return value;
      const reg = new RegExp(`(${keyword})|${keyword.toUpperCase()}`, 'g');
      value = value.replace(
        reg,
        ($1) => `<b style='color: #FF9E2D;'>${$1}</b>`,
      );
      return value;
    },
    curIds() {
      return this.curs.map((it) => it.id);
    },
    isChoose() {
      return this.curIds.includes(this.info.id);
    },
    disable() {
      const { from } = this.info;
      const max = PROMO_CONDITION[from];
      if (this.info.needClaim) return false;
      if (this.curIds.length >= max && !this.isChoose) return true;
      return !this.info.available;
    },
  },
  methods: {
    onShowDetail() {
      this.$emit('onShowDetail', this.info, this.disable);
    },
    onChoose() {
      if (this.disable) return;
      const { info } = this;
      this.$emit('onChoose', info, this.isChoose); // 只能切换
    },
    onClickClaimBtn() {
      this.$emit('claim');
    },
  },
};
</script>

<style scoped lang="scss">
.vitem {
  height: 86px;
  border: 1px solid #d1d5db;
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  border-radius: 8px;
  gap: 16px;
  padding-right: 16px;
  &.disable {
    .vitem-left {
      opacity: 0.4;
    }
  }
  &-left {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-left: 20px;
    font-size: 12px;
    max-width: 220px;
    & div + div {
      padding-top: 3px;
    }
    &-title {
      font-weight: bold;
      font-size: 14px;
    }
    &-minimum {
      align-self: flex-start;
    }
  }
  &-right {
    &-check {
      width: 20px;
      height: 20px;
      display: inline-block;
      font-size: $font-size-5;
      margin-right: 12px;
      &.nocheck {
        color: $border;
      }
      &.check {
        color: $black;
      }
    }

    .claim-btn {
      display: flex;
      width: 68px;
      height: 32px;
      padding: 12px 16px;
      box-sizing: border-box;
      justify-content: center;
      align-items: center;

      color: var(--White, var(--white, #FFF));
      font-size: 12px;
      font-style: normal;
      font-weight: 800;
      line-height: 120%; /* 14.4px */
    }
  }
}
</style>
